import { MasterDialog } from "#common/Dialog/Dialog"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { competenceIdGet } from "#competence/services/Api"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Box, Grid, Skeleton } from "@mui/material"
import { useEffect, useMemo } from "react"
import CustomizedAccordions from "./CompetenceInfoAccordion"
import CompetenceInfoGeneral from "./CompetenceInfoGeneral"
import { CompetenceInfoHeader } from "./CompetenceInfoHeader"

export const CompetenceInfoDialog = ({ id, open, setOpen }) => {
	return (
		<MasterDialog {...{ open, setOpen, title: "Información" }} maxWidth="md">
			<CompetenceInfo id={id} />
		</MasterDialog>
	)
}

export default function CompetenceInfo({ id }) {
	const params = useMemo(() => ({ id }), [id])
	const { setCompetence } = UseContextsCompetence()

	const { data, error, loading } = useApi(competenceIdGet, {
		autoFetch: !!params?.id,
		params,
	})

	useEffect(() => {
		if (data?.id) setCompetence(data)
	}, [data, setCompetence])

	if (loading) return <Skeleton variant="rectangular" width={"100%"} height={"82vh"} />

	if (error) return <ErrorResponse />

	const itemData = {
		usageCount: 12,
		...data,
	}

	return (
		<Box>
			<CompetenceInfoHeader data={itemData} />

			<Grid container spacing={3}>
				{/* Información General */}
				<Grid item xs={12}>
					<CompetenceInfoGeneral data={itemData} />
				</Grid>

				<Grid item xs={12}></Grid>
			</Grid>
			<CustomizedAccordions />
		</Box>
	)
}
